import React, { useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import BackArrow from "../../assets/svg/back-arrow.svg";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import PrimaryButton from "../../components/Button/PrimaryButton";
import "./style.scss";
import { AppDispatch } from "../../store/store";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import { showToast } from "../../components/Toast";
import MainLayout from "../../layout/MainLayout";
import {
  handleAuthOtp,
  handleResendOtp,
} from "../../store/reducers/authentication/apiThunk";

const VerifyOTP = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loginData = useSelector((state: any) => state);
  const {
    authentication: {
      login: { mobileNo = "" },
    },
  } = loginData;
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const timerRef = useRef<number>(60);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [resendOtp, setResendOtp] = useState(false)
  useEffect(() => {
    if (mobileNo === "") {
      navigate(ROUTE_PATH.LOGIN);
    }
  }, []);

  useEffect(() => {
    // Function to update window width
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener to update width on window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Manage the timer
  useEffect(() => {
    const interval = setInterval(() => {
      if (timerRef.current > 0) {
        timerRef.current -= 1;
        setTimer(timerRef.current); // Update state only when necessary
      } else {
        setCanResend(true);
        clearInterval(interval);
      }
      setResendOtp(false)
    }, 1000);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [resendOtp]); // Empty dependency array ensures this effect runs only once

  const handleResend = async () => {
    console.log("Resend OTP");
    const data = {
      "mobileNo": mobileNo,
    };
    try {
      const res = await dispatch(handleResendOtp(data)).unwrap(); // Unwraps to return raw result or throw error
      console.log("fetchResendOTP", res);
      if (res?.status === 1) {
        setTimer(60);
        timerRef.current = 60
        setResendOtp(true)
        setCanResend(false);
      }
    } catch (error) {
      showToast("Something went wrong", "error");
      console.error("Error saving user data:", error);
    }
  };

  const handleChange = (index: number, value: string) => {
    if (isNaN(Number(value))) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const otpCode = otp.join("");
    if (otpCode.length < 6) {
      setError(true);
      setErrorMsg("Please enter all 6 digits.");
    } else {
      setError(false);
      const data = {
        "mobileNumber": mobileNo,
        otp: otpCode,
      };

      try {
        const res = await dispatch(handleAuthOtp(data)).unwrap(); // Unwraps to return raw result or throw error
        console.log("fetchResendOTP", res);
        if (res?.status === 1) {
          localStorage.setItem(
            "auth",
            "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDb3ZlcnN1cmUgVG9rZW4iLCJleHAiOjE3MzcxMzg2MDB9.KMIn9Nc2WihqbYL-ONZSaw8NNCCz_BShtYfKFSL0mXNifqT1goeIjIMR5wfyDIh_4uWZSnqewRhdsmiBxybRlA"
          );
          if (windowWidth > 600) {
            navigate(ROUTE_PATH.WELLNESS);
          }else{
            navigate(ROUTE_PATH.DASHBOARD)
          }
        }
      } catch (error) {
        showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
      console.log("Submitted OTP:", data);
    }
  };

  const handleKeyDown = (index: number, event: React.KeyboardEvent) => {
    if (event.key === "Backspace" && otp[index] === "") {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const mainDiv = () => {
    return (
      <div className="verify-otp-css flex justify-center flex-col items-center w-[100%] sm:h-[100vh] lg:px-[73px]">
        <div className="flex justify-center flex-col items-center sm:w-[60%] lg:w-[100%] sm:rounded-[30px] lg:rounded-[0] sm:bg-bg-color-3 lg:bg-transparent sm:shadow-custom-light lg:shadow-none sm:p-[16px] lg:p-[0]">
          <div className="lg:flex flex-col items-center justify-center lg:mb-[36px] mb-[24px]">
            <img
              src={CoversureLogo}
              alt="CoversureLogo"
              className="hidden lg:block lg:w-[400px] w-[175px] pt-[50px] lg:p-0"
            />
            <div className="text-center lg:text-[30px] text-[22px] lg:leading-[32px] font-semibold lg:mt-[50px] mt-[15px] lg:mb-[15px] mb-[7px] tracking-tighter text-text-color-5 flex items-center lg:block">
              <img
                src={BackArrow}
                alt="BackArrow"
                className="block lg:hidden relative left-[-5%]"
                onClick={() => navigate(-1)}
              />
              <span className="relative top-[-5px]">Verify OTP</span>
            </div>
            <div className="text-center lg:text-[18px] text-[15px] lg:leading-[22px] leading-[18px] tracking-tight text-text-color-5 pb-[40px]">
              Enter the 6 digit verification code sent to your mobile number
            </div>
            <div className="lg:text-[24px] text-[28px] leading-[28px] text-text-color-5 font-bold">
              {mobileNo}
            </div>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="flex space-x-2">
              {otp.map((digit, index) => (
                <TextField
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  value={digit}
                  inputProps={{ maxLength: 1, className: "text-center" }}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onChange={(e) => handleChange(index, e.target.value)}
                  className="xl:w-[75px] lg:w-[60px] sm:w-[50px] bg-bg-color-4 lg:bg-bg-color-2 text-sm font-medium"
                  error={error && otp[index] === ""}
                />
              ))}
            </div>
            {error && (
              <div className="text-text-color-6 text-[14px] font-medium">
                {errorMsg}
              </div>
            )}
            <div className="lg:text-[16px] lg:leading-[16px] font-semibold text-center lg:pt[26px] hidden lg:block">
              Didn’t get the OTP?{" "}
              <span className="text-text-color-4">
                {canResend ? (
                  <span
                    className="text-text-color-4 cursor-pointer"
                    onClick={handleResend}
                  >
                    Resend OTP
                  </span>
                ) : (
                  <span className="text-text-color-4">Resend ({timer}s)</span>
                )}
              </span>
            </div>
            <div className="w-[100%] lg:pt-[34px] pt-[22px]">
              <PrimaryButton
                type="submit"
                classname="lg:w-[80%] w-[100%] m-auto"
                label={
                  <div className="flex items-center justify-center w-[100%] font-black">
                    <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] ">
                      Continue
                    </div>
                  </div>
                }
              />
            </div>
            <div className="text-[12px] leading-[16px] font-semibold text-center lg:pt[24px] block lg:hidden">
              Didn’t get the OTP?{" "}
              <span className="text-text-color-4">
                {canResend ? (
                  <span
                    className="text-text-color-4 cursor-pointer"
                    onClick={handleResend}
                  >
                    Resend OTP
                  </span>
                ) : (
                  <span className="text-text-color-4">Resend ({timer}s)</span>
                )}
              </span>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return windowWidth > 1000 ? <MainLayout>{mainDiv()}</MainLayout> : mainDiv();
};

export default VerifyOTP;
